import { change } from 'redux-form';
import { VARIABLE_PRICING_FORM } from '../constants';

const onChangePricingForm = (field, newValue = null, dispatch) => {
  dispatch(change(VARIABLE_PRICING_FORM, field, newValue));
};

export default onChangePricingForm;
